"use client";
import { useEffect, useState } from "react";
import { Container, Skeleton, Text } from "@radix-ui/themes";
import { useTranslations } from "next-intl";
import { LayoutProps } from "@/components/layout/layoutType";
import Icon from "@/components/common/icon/sicon";
// import dynamic from "next/dynamic";
// const Icon = dynamic(() => import("@/components/common/icon/icon"), { ssr: false });

export default function NotFound({ params }: { params?: LayoutProps }) {
  const t = useTranslations("alert");
  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <Container size="1" className=" mt-16 lg:mt-32 text-center group">
      <Skeleton loading={loading}>
        <Icon
          iconType="phosphor"
          iconName="GlobeSimpleX"
          className={"size-64 inline-block animate-infinite group-hover:animate-wiggle"}
          weight="thin"
          size={64}
        />
      </Skeleton>

      <Skeleton loading={loading}>
        <Text as="div" size="4" weight="bold" className="flex min-w-12 justify-center mt-12">
          {t("nopage_text")}
        </Text>
      </Skeleton>
    </Container>
  );
}
